import React, { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { useAtom } from "jotai";
import SearchResults from "./SearchResults";
import {
  ModalV2,
  ModalV2BackButton,
  ModalV2Body,
  ModalV2Header,
} from "../../components/modals/ModalV2";
import { selectedSearchAtom } from "../../jotai/atoms";
import { SearchStatus } from "../../models/Interfaces";

interface SearchResultsModalProps {
  onContinue: () => void;
  onDelete: () => void;
}

export const SearchResultsModal = forwardRef<HTMLDialogElement, SearchResultsModalProps>(
  function SearchResultsModal({ onContinue, onDelete }, ref) {
    const { t } = useTranslation();
    const [existingSearch] = useAtom(selectedSearchAtom);

    const noMatch = existingSearch?.status === SearchStatus.noMatch;
    const multiMatch = existingSearch?.status === SearchStatus.multiMatch;
    const isScenarioB =
      existingSearch?.status === SearchStatus.partialMatchAltContacts &&
      !existingSearch?.dateVerified;

    function getSearchStatusTextHeader() {
      if (isScenarioB || noMatch || multiMatch) {
        return t("immunizations.search_results_troubleshooting");
      }
      return t("immunizations.search_queued_header");
    }

    return (
      <ModalV2 modalBoxClassName="bg-base-100 max-w-3xl" ref={ref}>
        <div>
          <ModalV2Header className="flex items-center justify-between py-2">
            <div className="flex items-center gap-2">
              <ModalV2BackButton />
              <p className="font-semibold text-xl">{getSearchStatusTextHeader()}</p>
            </div>
          </ModalV2Header>
        </div>
        <ModalV2Body className="bg-base-100 pt-2">
          <SearchResults
            onDelete={onDelete}
            onContinue={onContinue}
            isScenarioB={isScenarioB}
            noMatch={noMatch}
            multiMatch={multiMatch}
          />
        </ModalV2Body>
      </ModalV2>
    );
  }
);

export default SearchResultsModal;
